<p-dropdown
  [options]="subChannels"
  [ngModel]="selectedSubChannelId"
  [disabled]="disabled || loading"
  [placeholder]="placeholder"
  (onChange)="onSubChannelChange($event)"
  optionLabel="name"
  optionValue="id"
>
  <ng-template pTemplate="item" let-item>
    <div class="channel-item">
      <span>{{ item.name }}</span>
    </div>
  </ng-template>

  @if (showRefreshFooter) {
    <ng-template pTemplate="footer">
      <div class="dropdown-footer">
        <span class="dropdown-footer-text">Can't find your board?</span>
        <button
          type="button"
          class="refresh-boards-btn"
          [class.loading]="loading"
          [disabled]="disabled || loading"
          (click)="onRefresh($event)"
        >
          @if (loading) {
            <p-progressSpinner
              class="refresh-spinner"
              strokeWidth="4"
              [style]="{ width: '14px', height: '14px' }"
            />
          }
          <span>↻ Refresh boards</span>
        </button>
      </div>
    </ng-template>
  }
</p-dropdown>
